// import {
// 	XMarkIcon,
// } from '@heroicons/react/24/outline'

// import {
// 	Squares2X2Icon,
// } from '@heroicons/react/24/outline'


import { string } from 'yup';

const obj = {
	field: [

		{
			title: "Topic",
			attr: "content",
			value: "",
			id: "Topic",
			placeholder: "Specify the content",
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Topic is Required "),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
	],
	example: [

		{
			title: "Topic",
			attr: "content",
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Topic is  Required "),

			value: `Cricket is a bat-and-ball game played between two teams of eleven players. The objective is to score runs by hitting the ball and running between two sets of wickets, while also preventing the opposing team from scoring runs.
To get started with cricket, you can join a local club or team and consider taking lessons from a coach. You can also practice with a cricket partner or friends.
To play cricket, you will need a cricket bat, cricket ball, protective gear such as a helmet, pads, gloves, and appropriate clothing and shoes.
To improve your cricket skills, you can practice regularly, take lessons from a coach, and participate in cricket camps or clinics. You can also watch and learn from more advanced players and matches. Additionally, working on your fitness and mental focus can help improve your overall game.
			`,
			id: "Topic",
			placeholder: "Specify the content",
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
	],

	editor: {
		output: `
		{
		  "@context": "http://schema.org",
			"@type": "FAQPage",
			"mainEntity": [{
				"@type": "Question",
				"name": "What is cricket?",           
				"acceptedAnswer": {                                           
				  "@type": "Answer",                                        
				  "text":"Cricket is a bat-and-ball game played between two teams of eleven players. The objective is to score runs by hitting the ball and running between two sets of wickets, while also preventing the opposing team from scoring runs."             } },{
  				 "@type": "Question",                      
			   "name":"How do I get started with cricket?",                    
				"acceptedAnswer": {                                           
				 "@type":"Answer",                                            
				"text":"To get started with cricket, you can join a local club or team and consider taking lessons from a coach. You can also practice with a cricket partner or friends."}},{
			   </pre>
		`








	}

}


export default obj

